import React from 'react';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductCatering } from 'Components/widgets/product-catering/ProductCatering';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import type { LineProps } from './resolver';

const ProductRestaurantsLine = ({
  config,
  restaurants: { introduction, restaurantsList = [] },
  title,
}: LineProps) => {
  const intros = introduction
    ? [
        {
          description: introduction.description,
        },
      ]
    : [];
  const list = restaurantsList.map((restaurant) => {
    const [image] = restaurant.images;
    return { ...restaurant, image };
  });
  return (
    <SiteContainer className="Line">
      <LineTitle>{title}</LineTitle>
      <ProductCatering
        intros={intros}
        list={list}
        seeLessLabel={config?.common?.loadLess ?? ''}
        seeMoreLabel={config?.common?.viewMore ?? ''}
      />
    </SiteContainer>
  );
};

export default ProductRestaurantsLine;
